export default function roundedNumberToString(
  number: number,
  roundAmount: number,
  withoutLocale?: boolean
) {
  if (!number) return String(0)
  if (withoutLocale) return String(+number.toFixed(roundAmount))
  return Number(+number.toFixed(roundAmount)).toLocaleString('da-DK')
}
